import { css } from 'styled-components';

const mixins = {
  flexCenter: css`
    display: flex;
    justify-content: center;
    align-items: center;
  `,

  flexBetween: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
  `,

  link: css`
    display: inline-block;
    text-decoration: none;
    text-decoration-skip-ink: auto;
    color: inherit;
    position: relative;
    transition: var(--transition);

    @media (hover: hover) {
      &:hover,
      &:focus-visible {
        color: var(--green);
        outline: 0;
      }
    }
  `,

  inlineLink: css`
    display: inline-block;
    position: relative;
    color: var(--green);
    transition: var(--transition);

    @media (hover: hover) {
      &:hover,
      &:focus-visible {
        color: var(--green);
        outline: 0;
        &:after {
          width: 100%;
        }
        & > * {
          color: var(--green) !important;
          transition: var(--transition);
        }
      }
    }
    &:after {
      content: '';
      display: block;
      width: 0;
      height: 1px;
      position: absolute;
      bottom: -2px;
      left: 0;
      background-color: var(--green);
      opacity: 0.5;
      @media (prefers-reduced-motion: no-preference) {
        transition: var(--transition);
      }
    }
  `,

  button: css`
    color: var(--green);
    background-color: transparent;
    border: 1px solid var(--green);
    border-radius: 4px;
    font-size: var(--fz-xs);
    font-family: var(--font-mono);
    line-height: 1;
    text-decoration: none;
    padding: 1.25rem 1.75rem;
    transition: var(--transition);
    position: relative;
    overflow: hidden;

    @media (hover: hover) {
      &:hover,
      &:focus-visible {
        outline: none;
        background: var(--green-tint);
      }
    }
    &:active {
      background: var(--green-tint);
      outline: none;
    }
  `,

  smallButton: css`
    color: var(--green);
    background-color: transparent;
    border: 1px solid var(--green);
    border-radius: 4px;
    padding: 0.75rem 1rem;
    font-size: var(--fz-xs);
    font-family: var(--font-mono);
    line-height: 1;
    text-decoration: none;
    transition: var(--transition);

    @media (hover: hover) {
      &:hover,
      &:focus-visible {
        outline: none;
        background: var(--green-tint);
      }
    }
    &:active {
      background: var(--green-tint);
      outline: none;
    }
  `,

  bigButton: css`
    color: var(--green);
    background-color: transparent;
    border: 1px solid var(--green);
    border-radius: 4px;
    padding: 1.25rem 1.75rem;
    font-size: var(--fz-sm);
    font-family: var(--font-mono);
    line-height: 1;
    text-decoration: none;
    transition: var(--transition);

    @media (hover: hover) {
      &:hover,
      &:focus-visible {
        outline: none;
        background: var(--green-tint);
      }
    }
    &:active {
      background: var(--green-tint);
      outline: none;
    }
  `,

  boxShadow: css`
    box-shadow: 0 10px 30px -15px var(--navy-shadow);
    transition: var(--transition);

    @media (hover: hover) {
      &:hover,
      &:focus-visible {
        box-shadow: 0 20px 30px -15px var(--navy-shadow);
      }
    }
  `,

  fancyList: css`
    padding: 0;
    margin: 0;
    list-style: none;
    font-size: var(--fz-lg);
    li {
      position: relative;
      padding-left: 30px;
      margin-bottom: 10px;
      &:before {
        content: '▹';
        position: absolute;
        left: 0;
        color: var(--green);
      }
    }
  `,

  resetList: css`
    list-style: none;
    padding: 0;
    margin: 0;
  `,
};

export default mixins;
